<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'
import {Russian} from 'flatpickr/dist/l10n/ru.js'
import moment from 'moment'

export default {

    page: {
        title: 'Новый отчет',
        meta: [{ name: 'description', content: appConfig.description }],
    },

    components: { Layout, PageHeader, Multiselect },

    data() {
        return {
            title: 'Новый отчет',
            items: [],
            report_uuid: '',
            name: '',
            trackBy: 'id',

            initStatus: [],
            status: null,
            status_options: [
                { id: 'created',   name: 'Новый' },
                { id: 'preparing', name: 'Подготовка' },
                { id: 'ready',     name: 'Готов' },
                { id: 'canceled',  name: 'Отменен' },
                { id: 'error',     name: 'Ошибка' },
            ],

            initType: [],
            type: null,
            types_options: [
                { id: 'calls', name: 'Звонки' },
            ],

            initBot: [],
            bot: null,
            bots_options: [],

            isSubmitErrorData: null,
            alertMessage: null,
            alertVariant: null,

            dateConfig: {
                mode: 'range',
                locale: Russian,
                dateFormat: 'd.m.Y',
            },

            date_start: moment().subtract('days', 1).format('DD.MM.YYYY'),
            date_end: moment().format('DD.MM.YYYY'),
            selectedDate: [moment().subtract('days', 1).format('DD.MM.YYYY'), moment().format('DD.MM.YYYY')],
        }
    },

    watch: {

        initStatus: {
            immediate: true,
            handler(values) {
                this.status = this.status_options.filter(x => values.includes(x[this.trackBy]));
                this.status = this.status[0];
            }
        },

        initType: {
            immediate: true,
            handler(values) {
                this.type = this.types_options.filter(x => values.includes(x[this.trackBy]));
                this.type = this.type[0];
            }
        },

        initBot: {
            immediate: true,
            handler(values) {
                this.bot = this.bots_options.filter(x => values.includes(x[this.trackBy]));
                this.bot = this.bot[0];
            }
        },
    },

    computed: {
        report_item(){
            return this.$store.getters['reports/GET_REPORTS_ITEM'];
        },
        bots_list_data(){
            return this.$store.getters['bots/GET_BOTS_LIST_DATA'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
    },

    async mounted() {

        this.report_uuid = this.$route.params.report_uuid ? this.$route.params.report_uuid : '';        

        await this.$store.dispatch('bots/FETCH_BOTS_LIST', {});
        this.bots_options = this.bots_list_data;

        if(this.report_uuid !== ''){

            this.title = 'Редактирование отчета';
            document.title = appConfig.title + ' - ' + 'Редактирование отчета';

            let data_send = {
                'uuid' : this.report_uuid
            }

            await this.$store.dispatch('reports/FETCH_REPORTS_ITEM', data_send);

            this.name = this.report_item.name ? this.report_item.name : '';
            this.status = this.report_item.status ? this.report_item.status : '';
            this.initStatus = [this.status];

            this.type = this.report_item.type ? this.report_item.type : '';
            this.initType = [this.type];

            this.report_params = JSON.parse(this.report_item.more_data);

            this.bot = this.report_params.bot_id ? this.report_params.bot_id : '';
            this.initBot = [this.bot];            

            if(this.report_params && this.report_params.date_start && this.report_params.date_end){
                this.date_start   = this.report_params.date_start;
                this.date_end     = this.report_params.date_end;
                this.selectedDate = [this.date_start, this.date_end];
            }
        }
    },

    methods: {

        async generateName(){

            let name = '';

            if(this.type && this.type.id && this.type.id === 'calls'){
                name = 'Звонки'
            }
            if(this.bot && this.bot.name ){
                name = name + ' ответственным: ' + this.bot.name;
            }
            if(this.date_start && this.date_end ){
                name = name + ' за период: ' + this.date_start + ' - ' + this.date_end;
            }

            return name;
        },
        
        async onChangePeriod(item){
            if(item[0] && item[1]){
                this.date_start = moment(item[0]).format('DD.MM.YYYY')
                this.date_end   = moment(item[1]).format('DD.MM.YYYY')
            }
        },

        async saveItem(){

            let err = false;
            let err_message = '';
            
            if(!this.type || !this.type.id){
                err = true;
                err_message = 'Вид отчета';
            }

            if(err === true){
                this.isSubmitErrorData = true;
                this.alertMessage = 'Не все обязательные поля были заполнены: ' + err_message;
                this.alertVariant = 'danger';

                return false;
            }            

            let data_send = {
                'name'      : await this.generateName(),
                'status'    : this.status && this.status.id ? this.status.id : 'created',
                'type'      : this.type   && this.type.id   ? this.type.id   : null,
                'activity_uuid': 'null',
                'more_data' : JSON.stringify({
                    'bot_id'     : this.bot && this.bot.id ? this.bot.id : null,
                    'date_start' : this.date_start,
                    'date_end'   : this.date_end
                })
            };

            let result = '';

            if(this.report_uuid === ''){
                result = await this.$store.dispatch('reports/FETCH_REPORTS_CREATE', data_send);
            } else {
                data_send.uuid = this.report_uuid;
                result = await this.$store.dispatch('reports/FETCH_REPORTS_UPDATE', data_send);
            }

            if(result === false){
                alert('Возникла ошибка');
            } else {
                this.$router.push({ name: 'Reports'});
            }
        }
    },
}

</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="saveItem"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">

                        <div class="row">
                            <div class="col">
                                <b-alert
                                    v-model="isSubmitErrorData"
                                    :variant="alertVariant"
                                    dismissible
                                >{{ alertMessage }}</b-alert>
                            </div>
                        </div>

                        <div class="row" style="margin-bottom: 20px">
                            <div class="col">
                               <span style="font-weight: bold">* - поля обязательные к заполнению</span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">

                                <b-form-group
                                    label="Вид отчета *"
                                    label-for="type"
                                >
                                    <multiselect
                                        id="type"
                                        :track-by="trackBy"
                                        v-model="type"
                                        :options="types_options"
                                        placeholder="Выберите из списка"
                                        selectLabel="Нажмите, чтобы выбрать"
                                        deselectLabel="Нажмите, снять выделение"
                                        label="name"
                                    ></multiselect>
                                </b-form-group>

                                <b-form-group
                                    label="Ответственный"
                                    label-for="bot"
                                >
                                    <multiselect
                                        id="bot"
                                        :track-by="trackBy"
                                        v-model="bot"
                                        :options="bots_options"
                                        placeholder="Выберите из списка"
                                        selectLabel="Нажмите, чтобы выбрать"
                                        deselectLabel="Нажмите, снять выделение"
                                        label="name"
                                    ></multiselect>
                                </b-form-group>

                                <b-form-group
                                    label="Период"
                                    label-for="date"
                                >
                                    <flat-pickr
                                        v-model="selectedDate"
                                        class="form-control"
                                        :config="dateConfig"
                                        @on-change="onChangePeriod"
                                        id="date"
                                    ></flat-pickr>
                                </b-form-group>

                                <b-form-group
                                    label="Статус"
                                    label-for="status"
                                >
                                    <multiselect
                                        id="status"
                                        :track-by="trackBy"
                                        v-model="status"
                                        :options="status_options"
                                        placeholder="Выберите из списка"
                                        selectLabel="Нажмите, чтобы выбрать"
                                        deselectLabel="Нажмите, снять выделение"
                                        label="name"
                                    ></multiselect>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
    </Layout>
</template>
